import set from 'lodash/set';
import get from 'lodash/get';
import isPlainObject from 'lodash/isPlainObject';

/*
 * Campo vazio ('') vale como não informado (undefined) na validação — senão um
 * número opcional em branco (Yup.number().nullable()) falharia com "Deve ser
 * um número". Percorre objetos e listas; só a cópia validada muda, os valores
 * do formulário continuam como foram digitados.
 */
export function prepararParaValidacao(valores) {
    const saida = Array.isArray(valores) ? [] : {};
    Object.keys(valores || {}).forEach(chave => {
        const valor = valores[chave];
        if (Array.isArray(valor)) {
            saida[chave] = valor.map(item => (Array.isArray(item) || isPlainObject(item))
                ? prepararParaValidacao(item)
                : (item !== '' ? item : undefined));
        } else if (isPlainObject(valor)) {
            saida[chave] = prepararParaValidacao(valor);
        } else {
            saida[chave] = valor !== '' ? valor : undefined;
        }
    });
    return saida;
}

/*
 * Valida um objeto contra um schema Yup e devolve os erros como mensagens
 * aninhadas no mesmo formato dos valores ({ pessoa: { nome: '...' },
 * rendas: [{ vlrRenda: '...' }] }). É o formato que os blocos de erro, a
 * mensagem da etapa e o destaque das abas consomem (inscricaoSections.js).
 * Sem erro, devolve {}.
 */
export async function validarComSchema(schema, valores) {
    if (!schema) return {};

    try {
        await schema.validate(prepararParaValidacao(valores), { abortEarly: false });
        return {};
    } catch (erro) {
        if (erro.name !== 'ValidationError') throw erro;

        const erros = {};
        const lista = erro.inner && erro.inner.length ? erro.inner : [erro];
        lista.forEach(item => {
            // Vale a primeira mensagem de cada campo, como na tela.
            if (item.path && get(erros, item.path) === undefined) {
                set(erros, item.path, item.message);
            }
        });
        return erros;
    }
}
